import { StoreName } from "../../decorators/StoreNameDecorator";
import API from "../../models/API";
import BatchClassRoleViewModel, {
  BatchClassRoleViewModelData,
} from "../../models/viewmodels/BatchClassRoleViewModel";
import { AbstractSaveableStore } from "../SaveableStore";

@StoreName("BatchClassRoleViewModelStore")
class BatchClassRoleViewModelStore<
  Number,
  _ extends BatchClassRoleViewModel,
> extends AbstractSaveableStore<Number, BatchClassRoleViewModel> {
  storedObjectKeysEquals(a: Number, b: Number): boolean {
    return a === b;
  }

  batchClassId: string;

  constructor(batchClassId: string) {
    super();
    this.batchClassId = batchClassId;
  }

  async saveBatch(roles: Number[]): Promise<boolean> {
    if (roles.length == 0) {
      return false;
    }
    return await API.post(
      `/v0/roles/${window.encodeURIComponent(this.batchClassId)}`,
      null,
      roles
        .map((r) => this.getWithoutLookup(r))
        .filter<BatchClassRoleViewModel>(
          (
            r: BatchClassRoleViewModel | undefined,
          ): r is BatchClassRoleViewModel => r != undefined,
        )
        .map((r: BatchClassRoleViewModel) => r.getSaveModel()),
    )
      .then((value: Response) => value.text())
      .then((value: string) => value === "true")
      .catch(() => {
        return false;
      });
  }

  saveByValue(value: BatchClassRoleViewModel): Promise<boolean> {
    return value.getSaveModel().save();
  }

  async lookup(key: Number): Promise<BatchClassRoleViewModel | undefined> {
    return await API.get(
      `/v0/role/${key}/${window.encodeURIComponent(this.batchClassId)}`,
    )
      .then(async (value: Response) => {
        if (!value.ok) {
          return undefined;
        }
        const roleData: BatchClassRoleViewModelData =
          (await value.json()) as BatchClassRoleViewModelData;
        if (roleData) {
          return new BatchClassRoleViewModel(roleData);
        } else {
          return undefined;
        }
      })
      .catch(() => {
        return undefined;
      });
  }
}

export { BatchClassRoleViewModelStore };
